export default [
    {
        date: 1585743760032,
        row: 4,
        col: 5,
        segments: [
            [2, 3, 4, 3],
            [4, 2, 4, 3],
            [3, 3, 4, 2],
            [3, 3, 2, 2],
            [2, 2, 2, 3],
        ],
    },
];
